/**
 * Shared Phone Validation
 * Reusable phone validation pattern used across features
 */

import { z } from "zod";

/**
 * Phone regex pattern
 * Matches common phone formats: +1234567890, (123) 456-7890, 123-456-7890
 */
export const phoneRegex = /^[+]?[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/;

/**
 * Zod schema for optional phone validation
 * - If provided, must match phone format
 * - Empty string or undefined is allowed
 */
export const phoneSchema = z
  .string()
  .optional()
  .refine(
    (val) => !val || phoneRegex.test(val),
    "Please enter a valid phone number"
  );

/**
 * Zod schema for required phone validation
 */
export const requiredPhoneSchema = z
  .string()
  .min(1, "Phone number is required")
  .regex(phoneRegex, "Please enter a valid phone number");

/**
 * Validate phone without Zod (for simple checks)
 */
export const isValidPhone = (phone: string): boolean =>
  !phone || phoneRegex.test(phone);
